<template>
  <div>
    <h2 class="step-name">Dogs</h2>

    <div class="step-section">
      <discussion-points
        title="Discussion"
        comments-field="discussion"
        points="Internal parasites, Diet, Joints/Mobility, Vaccinations - Vanguard, Kennel cough"
      >
      </discussion-points>
    </div>

    <div class="step-section">
      <h3>Dogs & vaccination due dates</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Code</th>
            <th>Breed</th>
            <th>Age</th>
            <th>Sex</th>
            <th>Core Vaccine due</th>
            <th>Canine Cough Vaccine due</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('dog_vax_reminders')" :key="index">
            <td class="text-left">{{ row['name'] }}</td>
            <td class="text-left">{{ row['animal_code'] }}</td>
            <td class="text-left">{{ row['breed'] }}</td>
            <td class="text-left">{{ row['age'] }}</td>
            <td class="text-left">{{ row['sex'] }}</td>
            <td class="text-left">{{ row['core_vax_due'] }}</td>
            <td class="text-left">{{ row['cough_vax_due'] }}</td>
          </tr>
        </tbody>
      </table>

      <div class="form-group discussion-box">
        <i
          class="glyphicon glyphicon-envelope"
          aria-hidden="true"
          data-toggle="tooltip"
          data-placement="top"
          title="Email might be generated"
        ></i>

        <span class="form-group">
          <label>Updated dog information</label>
          <comments field-name="dogs_notes_for_farm_services" @on-change="toggleNotification"></comments>
        </span>

        <div class="alert alert-info">
          <p>Please let farm services know about any new dogs and any deaths or losses</p>
        </div>
      </div>
    </div>

    <div class="step-section">
      <programme-input programme-slug="dog-worming"> </programme-input>
      <text-input
        label="If not using VetSouth, who is your current worming programme provider?"
        field-name="dogs_other_worming_provider"
      >
      </text-input>
      <programme-input programme-slug="working-dog-run" @on-change="setDogVaxRun">
        <div class="alert alert-danger" v-if="!validate()">The dog run field is required.</div>
      </programme-input>
      <radio-input
        label="Interested in diet trial for light dogs?"
        :add-email-notification="true"
        @on-change="toggleNotification"
        field-name="dogs_wants_diet_trial"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import { mapGetters } from 'vuex'
import { prefixedField } from '../../_helpers'

export default {
  name: 'Dogs',
  mixins: [baseComponent],
  computed: {
    ...mapGetters('currentConsult', ['getProgram']),
  },
  mounted() {
    let fieldName = prefixedField('active_after', this.getProgram('working-dog-run').id, 'cm')
    let fieldValue = this.getFieldValue(fieldName, 'Programmes')
    if ([true, false].includes(fieldValue)) {
      this.setDogVaxRun({value: fieldValue})
    }
  },
  methods: {
    setDogVaxRun: function ({ value }) {
      this.setFieldValue({ modelName: this.$options.name, value: value ? 'Yes' : 'No', fieldName: 'dogs_vax_run' })
      this.setEmailNotification({ slug: 'dog-vax-run', value: value })
      this.checkAndCompleteStep()
    },
    toggleNotification: function ({ fieldName, value }) {
      if (fieldName == 'dogs_wants_diet_trial') {
        this.setEmailNotification({
          slug: 'interested-in-diet-trial-for-light-dogs',
          value: value == 'Yes' ? true : false,
        })
      } else if (fieldName == 'dogs_notes_for_farm_services') {
        this.setEmailNotification({ slug: 'dogs-notes-for-farm-services', value: value ? true : false })
      }
    },
    validate() {
      return ['Yes', 'No'].includes(this.getFieldValue('dogs_vax_run', this.$options.name))
    },
  },
}
</script>

<style scoped>
i {
  margin-right: 0.5em;
}
</style>
